<div class="fw-bold bg-white p-3 rounded-5 mb-3 shadow">
  <!-- Primera fila -->
  <div class="d-flex justify-content-between">
    <div class="">
      <label for="information" class="labelInformation">{{
        information
      }}</label>
    </div>
    <div class="">
      <button class="btn btn-secondary" (click)="goBack()">Back</button>
    </div>
  </div>

  <!-- Segunda fila -->
  <div class="row row-cols-1 row-cols-md-3 row-gap-3">
    <div class="col">
      <label for="customerName"
        >Customer name<span class="required">*</span></label
      >
      <input
        type="text"
        class="form-control input-label"
        (input)="checkFields()"
        [(ngModel)]="customerName"
      />
    </div>
    <div class="col">
      <label for="address" class="">Address</label>
      <input type="text" style="display:none" />  <!-- Чтобы не отображался диалог сохранения адреса -->
      <input type="text" class="form-control input-label" (input)="checkFields()" [(ngModel)]="address" />
    </div>
    <div class="col">
      <label for="customerCity">City</label>
      <input
        type="text"
        class="form-control input-label"
        (input)="checkFields()"
        [(ngModel)]="city"
      />
    </div>
    <div class="col">
      <label for="state" class="input-label">State</label>
      <div class="dropdown">
        <select
          class="form-select input-label"
          [(ngModel)]="stateSelected"
          (change)="checkFields()"
        >
          <option value="">Select Value</option>
          <option *ngFor="let option of states" [value]="option.aValue">
            {{ option.aDescription }}
          </option>
        </select>
      </div>
    </div>
    <div class="col">
      <label for="zipCode" class="">ZIP code</label>
      <input
        type="number"
        class="form-control input-label"
        (input)="checkFields()"
        [(ngModel)]="zipCode"
      />
    </div>
    <div class="col">
      <label for="mainContact" class="">Main contact</label>
      <input
        type="text"
        class="form-control input-label"
        (input)="checkFields()"
        [(ngModel)]="mainContact"
      />
    </div>
    <div class="col">
      <label for="contactNumber" class=""
        >Contact number<span class="required">*</span></label
      >
      <input
        type="text"
        class="form-control input-label"
        (input)="checkFields()"
        [(ngModel)]="contactNumber"
        appFormatPhoneUs
      />
    </div>
    <div class="col">
      <label for="additionalContactNumber" class=""
        >Additional contact number</label
      >
      <input
        type="text"
        class="form-control input-label"
        (input)="checkFields()"
        [(ngModel)]="additionalContactNumber"
        appFormatPhoneUs
      />
    </div>
    <!-- Tercera fila -->
    <div class="col">
      <form [formGroup]="form">
        <label for="email">Email<span class="required">*</span></label>
        <input
          type="email"
          class="form-control input-label"
          formControlName="email"
          [(ngModel)]="email"
          name="email"
          (change)="checkEmailValidity()"
          (input)="checkFields()"
          appFormatEmail
        />
        <div *ngIf="emailModel?.errors?.['emailInvalid']">
          Email is not valid
        </div>
      </form>
    </div>
    <div class="col">
      <label for="seniorityDate">Customer Since</label>
      <input
        type="date"
        class="form-control input-label"
        (input)="checkFields()"
        [(ngModel)]="seniorityDate"
        id="seniorityDate"
        name="seniorityDate"
        [max]="today"
      />
    </div>
  </div>

  <!-- Cuarta fila -->
  <div class="row mt-3">
    <div class="col text-end">
      <button
        class="btn btn-primary w-100 w-md-auto"
        [disabled]="!fieldsCompleted"
        (click)="updateCustomer()"
      >
        Save customer info
      </button>
    </div>
  </div>
</div>
